// extracted by mini-css-extract-plugin
export default {"imgbgColor":"var(--image-bg-color)","loader-position":"Loader_loader-position__lVknU"};